import { createSelector } from 'reselect';
import type { RootState } from '@/app/store';

export const selectSettings = (state: RootState): RootState['settings'] => state.settings;
export const selectTheme = createSelector(selectSettings, (s) => s.theme);
export const selectSidebarCollapsed = createSelector(selectSettings, (s) => s.sidebarCollapsed);
